/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
/* eslint-disable @typescript-eslint/camelcase, react/no-unescaped-entities */
// eslint-disable-next-line lodash-fp/consistent-name, lodash-fp/use-fp
import { round, get } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import DownCarot from '../../../assets/icons/carat.svg'
import List from '../../../components/List'
import DistChart from './ChartComponents/Distribution'
import Donut from './ChartComponents/Donut'

class BodyComposition extends React.Component {
  constructor(props) {
    super(props)

    // getinitialState
    this.state = {
      donutData: this.donutData(),
      bodyFat: this.BodyFatData(),
      skeletalData: this.SkeletalData(),
      visceralData: this.VisceralFatData()
    }
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({
      donutData: this.donutData(),
      bodyFat: this.BodyFatData(),
      skeletalData: this.SkeletalData(),
      visceralData: this.VisceralFatData()
    })
  }

  donutData() {
    let { details } = this.props

    let weight = round(details.weight.value, 2)
    let bf = round(details.body_fat_mass.value)
    let sm = round(details.skeletal_muscle_mass.value)
    let other = round(details.other.value)

    if (
      !details.body_fat_mass.__ok ||
      !details.skeletal_muscle_mass.__ok ||
      !details.other.__ok
    ) {
      details.body_fat_mass.value = 25
      details.skeletal_muscle_mass.value = 25
      details.other.value = 50
      weight = 0
      bf = 0
      sm = 0
      other = 0
    }

    console.log('value ==> ', details.percent_body_fat.value)
    console.log('roundValue ==> ', round(details.percent_body_fat.value, 2))

    return {
      centerValue: {
        value: weight + ' ' + details.weight.unit,
        label: ''
      },
      chartData: [
        {
          legend: details.body_fat_mass.display_label,
          value: round(details.percent_body_fat.value, 2), // FIXME: data format: key should be 'value', not the unit
          label: bf + ' ' + details.body_fat_mass.unit,
          fill: '#000000',
          stroke: '#FF8874'
        },
        {
          legend: details.skeletal_muscle_mass.display_label,
          value: round(details.percent_skeletal_muscle.value, 2),
          label: sm + ' ' + details.skeletal_muscle_mass.unit,
          fill: 'none',
          stroke: 'none'
        },

        {
          legend: details.other.display_label,
          value: round(details.percent_other.value, 2),
          label: other + ' ' + details.other.unit,
          fill: 'url(#donut_chart_gradient)',
          stroke: 'url(#donut_chart_gradient)'
        }
      ]
    }
  }

  BodyFatData() {
    const { details } = this.props
    let bfstats = get(details, 'percent_body_fat', {
      display_label: 'Body Fat Mass',
      unit: 'Percent',
      value: 0,
      interpretation: 'NODATA',
      percentile: 0,
      ranges: [],
      test_name: null,
      density_plot: [[0, 0], [1, 0]]
    })

    details.percent_body_fat = bfstats

    return {
      display_label: bfstats.display_label,
      unit: bfstats.unit,
      value: bfstats.value,
      interpretation: bfstats.interpretation,
      percentile: bfstats.percentile,
      ranges: bfstats.ranges,
      test_name: bfstats.test_name,
      density_plot: bfstats.density_plot
    }
  }

  SkeletalData() {
    const { details } = this.props

    let sdstats = get(details, 'percent_skeletal_muscle', {
      display_label: 'Skeletal Muscle Mass',
      unit: 'Percent',
      value: 0,
      interpretation: 'NODATA',
      percentile: 0,
      ranges: [],
      test_name: null,
      density_plot: [[0, 0], [1, 0]]
    })
    details.percent_skeletal_muscle = sdstats

    return {
      display_label: sdstats.display_label,
      unit: sdstats.unit,
      value: sdstats.value,
      interpretation: sdstats.interpretation,
      percentile: sdstats.percentile,
      ranges: sdstats.ranges,
      test_name: sdstats.test_name,
      density_plot: sdstats.density_plot
    }
  }

  VisceralFatData() {
    const { details } = this.props
    let vstats = details.visceral_fat_level

    return {
      display_label: vstats.display_label,
      unit: vstats.unit,
      value: vstats.value,
      interpretation: vstats.interpretation,
      percentile: vstats.percentile,
      ranges: vstats.ranges,
      test_name: vstats.test_name,
      density_plot: vstats.density_plot
    }
  }

  render() {
    const { details, index, hotload } = this.props

    const items = {
      physicalActivity: {
        title: '<h2 class="mobile-padding">Body Composition</h2>',
        icon: { src: DownCarot },
        isShowAccordianOnMobile: true,
        accordianContent: `
      <div class="mobile-padding">
            <div>
              <p class="noMarginPadding">
                Body composition analysis determines the percentages of fat, muscle,
            water, and bone in a person’s body. The ratio and distribution of
            these components varies from person to person and can have profound
            health implications.
              </p>
            </div>
              <br/>
          </div>`
      }
    }
    const listProps = {
      items,
      isMobile: this.props.isMobile,
      isNoTopBorder: true,
      isNotSpacer: true,
      isCollapsedDark: true,
      isReportStyle: true
    }

    const showDonut = !(
      details.body_fat_mass.__ok &&
      details.skeletal_muscle_mass.__ok &&
      details.other.__ok
    )

    return (
      <div className="bodycomp-content module-content">
        <div className="intro-zone">
          {this.props.isMobile ? (
            <List {...listProps} />
          ) : (
            <p>
              Body composition analysis determines the percentages of fat,
              muscle, water, and bone in a person’s body. The ratio and
              distribution of these components varies from person to person and
              can have profound health implications.
            </p>
          )}
        </div>

        {hotload ? (
          <div className="mobile-padding">
            {!this.props.isMobile && <hr />}

            <div className="bucket">
              <Donut
                details={details}
                indentifier={'BodyComposition'}
                index={index}
                data={this.state.donutData}
                triggerMan={this.state.sizestate}
              />
              {showDonut ? (
                <div className="no-report-data">{`No Data Available`}</div>
              ) : null}
            </div>
            <hr />

            <div className="bodyfat bucket">
              <div className="table">
                <div className="trow">
                  <div className="td even-width">
                    <strong className="subject">Body Fat Mass</strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {round(details.percent_body_fat.value)}%
                    </strong>
                    <span className="descriptor">Percent</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.percent_body_fat.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'BodyFat'}
                      details={details}
                      index={index}
                      data={this.state.bodyFat}
                    />
                  </div>
                </div>
              </div>
              <p>
                Body fat mass is the total weight of fat, including surface
                (subcutaneous) fat and internal (visceral) fat stored around
                abdominal organs. What is considered a ‘healthy' amount of body
                fat differs based on age, gender, and other factors.
              </p>

              {!details.percent_body_fat.__ok ? (
                <div className="no-report-data">
                  {`No ${details.percent_body_fat.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />

            <div className="skeletal bucket">
              <div className="table">
                <div className="trow">
                  <div className="td even-width">
                    <strong className="subject short-subject">
                      Skeletal Muscle Mass
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {round(details.percent_skeletal_muscle.value)}%
                    </strong>
                    <span className="descriptor">Percent</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.percent_skeletal_muscle.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Skeletal'}
                      details={details}
                      index={index}
                      data={this.state.skeletalData}
                    />
                  </div>
                </div>
              </div>
              <p>
                Skeletal muscle mass is the total weight of muscles that can be
                grown and developed through exercise.
              </p>
              {!details.percent_skeletal_muscle.__ok ? (
                <div className="no-report-data">
                  {`No ${details.percent_skeletal_muscle.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />
            <div className="visceral bucket">
              <div className="table">
                <div className="trow">
                  <div className="td even-width">
                    <strong className="subject">Visceral Fat Level</strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.visceral_fat_level.value}
                    </strong>
                    <span className="descriptor">Level</span>
                  </div>
                  <div className="td even-width" />

                  <div className="td">
                    <DistChart
                      label={'Visceral'}
                      details={details}
                      index={index}
                      data={this.state.visceralData}
                    />
                  </div>
                </div>
              </div>
              <p>
                Visceral fat is internal abdominal fat surrounding body organs.
                It is closely associated with cardiovascular disease.
              </p>
              {!details.visceral_fat_level.__ok ? (
                <div className="no-report-data">
                  {`No ${details.visceral_fat_level.display_label} Data Available`}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

BodyComposition.propTypes = {
  details: PropTypes.object.isRequired
}

export default BodyComposition
